import React from 'react'
import Logo from '../../Assets/Images/banner.png'
import DLogo from '../../Assets/Images/logostrip2.png'
import BackButton from '../BackButton/BackButton'
import './LogoStrip.scss'

const LogoStrip = () => {
  return (
    <div className='logoStrip'>
      <picture className='logoStrip_Banner'>
        <source media='(min-width: 1280px)' srcSet={DLogo} />
        <img src={Logo} alt='logostrip' decoding='async' fetchPriority='high' />
      </picture>
      <BackButton />
    </div>
    
  )
}

export default LogoStrip
